export default __webpack_public_path__ + "static/media/grid_8.fa822133.png";